import Marquee from "react-fast-marquee";
import { outlets } from "@/data/press";

export const Testimonials = () => {
  return (
    <section data-testid="trusted-section" className="bg-navy text-ivory py-16 border-y border-white/10 grain relative overflow-hidden">
      <div className="relative">
        <p className="overline text-gold text-center mb-10">Placed &amp; quoted in</p>
        <Marquee speed={30} gradient gradientColor="#0B162C" gradientWidth={120} pauseOnHover>
          {outlets.map((o) => (
            <span key={o} className="font-serif font-light text-2xl sm:text-3xl text-ivory/60 mx-10 whitespace-nowrap">
              {o}
            </span>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
